module.exports = __webpack_public_path__ + "img/img_map.7ab18d6e.png";